
export const stateNameFormatter = (stateName) => {

    let state = stateName?.toLowerCase()?.trim()
    // replace all spaces with -
    state = state.replace(/\s/g, "-")
    return state
}